export default __webpack_public_path__ + "static/four-editors-23e1084a1fa07a1e371745d37979e96d.png";